import {BuildRequest} from '@flexiblelibrary/js-requests'

export default class UserAuthRequest extends BuildRequest  {
	constructor(props) {
		super(props, 'UserAuthRequest');
	}

	login(data = {}) {
		return this.request(this.method.login, {post:data});
	}
	
	getPermissions() {
		return this.request(this.method.getPermissions, {});
	}
}
